exports.feedMaskPixelTypes = {
  BIN_WALL: 0,
  FEED: 1,
  OBSTRUCTION: 2,
  NOISE: 3,
};

/**
 * @typedef {[[Number]]} FeedMask
 */

/**
 * Makes a feed mask of a given height and width filled with a single value
 * @param {Number} height
 * @param {Number} width
 * @param {Number} value
 * @returns {FeedMask}
 */
exports.makeFeedMask = (height, width, value = 0) => {
  const rows = [];
  for (let i = 0; i < height; i++) {
    const row = [];
    for (let j = 0; j < width; j++) {
      row.push(value);
    }
    rows.push(row);
  }
  return rows;
};

